import { ASSETS, COMPANY, scrollToSection } from "@/data/products";

const NAV = [
  { label: "Home", id: "home" },
  { label: "About Us", id: "about" },
  { label: "Products", id: "products" },
  { label: "How to Order", id: "how-to-order" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-charcoal text-cream/80">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3">
        <div>
          <img
            src={ASSETS.logo}
            alt="RIMBARA MAJU SDN BHD logo"
            className="h-14 w-auto rounded-lg bg-cream object-contain p-1"
            loading="lazy"
          />
          <p className="mt-4 text-sm font-semibold text-cream">{COMPANY.name}</p>
          <p className="mt-1 text-xs text-cream/60">SSM: {COMPANY.ssm}</p>
          <p className="mt-3 max-w-xs text-xs leading-relaxed text-cream/60">{COMPANY.address}</p>
        </div>
        <nav aria-label="Footer navigation">
          <h3 className="text-sm font-semibold uppercase tracking-[0.15em] text-bronze-light">
            Navigate
          </h3>
          <ul className="mt-4 space-y-2.5">
            {NAV.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  onClick={() => scrollToSection(item.id)}
                  className="text-sm text-cream/70 transition-colors hover:text-cream"
                  data-testid={`footer-nav-${item.id}`}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-[0.15em] text-bronze-light">
            Contact
          </h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <a
                href={`https://wa.me/${COMPANY.whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-cream/70 transition-colors hover:text-cream"
                data-testid="footer-whatsapp-link"
              >
                WhatsApp: {COMPANY.phoneIntl}
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} className="text-cream/70 transition-colors hover:text-cream" data-testid="footer-email-link">
                {COMPANY.email}
              </a>
            </li>
            <li>
              <a href={`tel:${COMPANY.phoneIntl}`} className="text-cream/70 transition-colors hover:text-cream" data-testid="footer-phone-link">
                {COMPANY.phoneDisplay}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <p className="mx-auto max-w-6xl px-4 py-5 text-center text-xs text-cream/50 sm:px-6">
          © {year} {COMPANY.name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
